import { filesApi, getNavigableFileDownloadUrl } from 'src/api/files';

export const fetchOpenableFileUrl = async (fileId: string): Promise<string> => {
  const file = await filesApi.getFile(fileId, { fresh: true });
  const ticketUrl = getNavigableFileDownloadUrl(fileId, file);
  if (ticketUrl) {
    return ticketUrl;
  }

  // GET /files mints downloadURL. Never use Mongo `url` (stale S3).
  if (file.downloadURL) {
    return file.downloadURL;
  }

  throw new Error('File URL is missing');
};

export const openCircleFileInNewTab = async (fileId: string): Promise<void> => {
  const preview = window.open('', '_blank');

  try {
    const url = await fetchOpenableFileUrl(fileId);
    if (preview) {
      preview.location.replace(url);
      return;
    }

    const fallback = window.open(url, '_blank');
    if (!fallback) {
      throw new Error('Popup blocked');
    }
  } catch (error) {
    preview?.close();
    throw error;
  }
};
